import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/featureGroup/license.featureGroup.features.query.gql"
import type {
  FeatureGroupFeaturesQuery,
  FeatureGroupFeaturesQueryVariables,
} from "@/v2-backoffice-client/license/featureGroup/__types__/license.featureGroup.features.query"

type Options = QueryHookOptions<
  FeatureGroupFeaturesQuery,
  FeatureGroupFeaturesQueryVariables
>

export function useFeatureGroupFeaturesQuery(options?: Options) {
  return useQuery<
    FeatureGroupFeaturesQuery,
    FeatureGroupFeaturesQueryVariables
  >(query, options)
}
